import React, { useMemo } from 'react';

import { Actions, Action } from '@gogame/components';
import { useGridApiContext } from '@gogame/data-grid';

import BatchAddTagsForm from 'scenes/Gallery/ConversionPages/ConversionPages/BatchAddTagsForm';

const BatchToolbar = ({ selectedRows, openChildComponent }) => {
  const handleAddTags = (selectedRows) => {
    openChildComponent(BatchAddTagsForm, {
      selectedRows: selectedRows.map(({ preview, ...row }) => ({
        ...row,
        src: preview,
      })),
    });
  };

  return (
    <Actions>
      <Action
        button={true}
        label={'Add Tags'}
        onClick={() => handleAddTags(selectedRows)}
      />
    </Actions>
  );
};

export default BatchToolbar;

export const BatchToolbarDataGrid = ({ selectedValues, ...props }) => {
  const {
    current: { getRow },
  } = useGridApiContext();

  const selectedRows = useMemo(() => {
    if (!getRow) {
      return selectedValues.map((id) => ({ id }));
    }

    return selectedValues.map((id) => getRow(id));
  }, [selectedValues, getRow]);

  return <BatchToolbar selectedRows={selectedRows} {...props} />;
};
